import { Icon } from '@pu/mpp-ui/components/icon';
import { useCSS } from '@pu/mpp-ui/hooks';
import type { INavLink } from '../side-nav-link';

import './side-nav-button.scss';

interface ISideNavButtonProps {
  link?: INavLink;
  isActive: boolean;
}

export const SideNavButton = ({ link, isActive }: ISideNavButtonProps) => {
  const css = useCSS('sidenav-button');

  return (
    <button type="button" className={css({ active: isActive })} onClick={link?.action}>
      <div className="sidenav-button__icon">
        <Icon name={link?.icon || 'globe'} weight={isActive ? 'bold' : 'regular'} />
      </div>
      <p className="sidenav-button__text">{link?.label}</p>
    </button>
  );
};
